import React from "react";
import { NavLink } from "react-router-dom";
import { makeLangUrl } from "helpers/makeLangUrl";
import url from "../../../url";
import useTranslate from "../../../hooks/useTranslate";
import "./styles.sass";

const CoinFestProfile = () => {
  const t = useTranslate();

  return (
    <div className="CoinFestProfile">
      <NavLink to={makeLangUrl(url.routes.coinFest.index())}>
        <picture>
          <source
            srcSet="https://diswdgcu9cfva.cloudfront.net/landings/casino/coinfestival/littlepoint.webp"
            media="(max-width: 576px)"
          />
          <img
            className="CoinFestProfile__img"
            src="https://diswdgcu9cfva.cloudfront.net/landings/casino/coinfestival/littlepoint-tab.webp"
            alt="Coin Fest"
          />
        </picture>

        <div className="CoinFestProfile__text">{t("coin.banner.title")}</div>
      </NavLink>
    </div>
  );
};

export default CoinFestProfile;
